define('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingLayoutView',['require','marionette','pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingListView','pwa/collection/DashboardSuggestedBookingCollection'],function (require) {

    var Marionette = require('marionette');
    var DashboardSuggestedBookingListView = require('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingListView');
    var DashboardSuggestedBookingCollection = require('pwa/collection/DashboardSuggestedBookingCollection');

    /**
     * @class DashboardSuggestedBookingLayout
     */
    return Marionette.LayoutView.extend({

        template: '#dashboard_suggested_booking_layout',
        regions: {
            suggestedBooking: '#sb_dashboard_suggested_booking_list',
        },

        onBeforeShow: function () {
            var collection = new DashboardSuggestedBookingCollection();
            var data = this.getOption('data');

            collection.fetch({
                data: data
            });

            this.listenTo(this.getOption('clientModel'), 'sync', function () {
                collection.fetch({
                    data: data
                });
            });

            this.showChildView('suggestedBooking', new DashboardSuggestedBookingListView({
                collection: collection,
            }));
        },

    });

});
